export function promo(state) {
  return state.promo;
}
